// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Tuple = require("relude/src/Relude_Tuple.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Extensions_Apply = require("relude/src/extensions/Relude_Extensions_Apply.bs.js");

function Make(T, M) {
  var map = function (f, decode) {
    var partial_arg = Curry._1(M.map, f);
    return function (param) {
      return Relude_Globals.$great$great(decode, partial_arg, param);
    };
  };
  var apply = function (f, decode, json) {
    return Curry._2(M.apply, Curry._1(f, json), Curry._1(decode, json));
  };
  var pure = function (v, param) {
    return Curry._1(M.pure, v);
  };
  var flat_map = function (decode, f, json) {
    return Curry._2(M.flat_map, Curry._1(decode, json), (function (__x) {
                  return Curry._2(f, __x, json);
                }));
  };
  var alt = function (a, b, json) {
    return Curry._2(T.lazyAlt, Curry._1(a, json), (function (param) {
                  return Curry._1(b, json);
                }));
  };
  var include = Relude_Extensions_Apply.ApplyExtensions({
        map: map,
        apply: apply
      });
  var map2 = include.map2;
  var map3 = include.map3;
  var map4 = include.map4;
  var map5 = include.map5;
  var flatMap = function (f, decode) {
    return function (param) {
      return flat_map(decode, f, param);
    };
  };
  var value = function (decode, failure, json) {
    return Relude_Option.foldLazy((function (param) {
                  return Curry._2(T.valErr, failure, json);
                }), M.pure, Curry._1(decode, json));
  };
  var $$boolean = function (param) {
    return value(Js_json.decodeBoolean, "ExpectedBoolean", param);
  };
  var string = function (param) {
    return value(Js_json.decodeString, "ExpectedString", param);
  };
  var floatFromNumber = function (param) {
    return value(Js_json.decodeNumber, "ExpectedNumber", param);
  };
  var isInt = function (v) {
    if (v === 0.0) {
      return true;
    } else {
      return v % Math.floor(v) === 0.0;
    }
  };
  var intFromNumber = function (param) {
    return flat_map(floatFromNumber, (function (v) {
                  if (!isInt(v)) {
                    return Curry._1(T.valErr, "ExpectedInt");
                  }
                  var partial_arg = v | 0;
                  return function (param) {
                    return Curry._1(M.pure, partial_arg);
                  };
                }), param);
  };
  var partial_arg = Curry._1(M.map, (function (prim) {
          return new Date(prim);
        }));
  var fromFloat = function (param) {
    return Relude_Globals.$great$great(floatFromNumber, partial_arg, param);
  };
  var partial_arg$1 = Curry._1(M.map, (function (prim) {
          return new Date(prim);
        }));
  var fromString = function (param) {
    return Relude_Globals.$great$great(string, partial_arg$1, param);
  };
  var isValid = function (date) {
    if (date.toJSON() == null) {
      return Curry._1(T.valErr, "ExpectedValidDate");
    } else {
      return function (param) {
        return Curry._1(M.pure, date);
      };
    }
  };
  var date = function (param) {
    return flat_map((function (param) {
                  return alt(fromFloat, fromString, param);
                }), isValid, param);
  };
  var variantFromJson = function (jsonToJs, jsToVariant) {
    var partial_arg = Curry._1(M.map, jsToVariant);
    var partial_arg$1 = function (param) {
      return Relude_Globals.$great$great(jsonToJs, partial_arg, param);
    };
    return function (param) {
      return flat_map(partial_arg$1, (function (param) {
                    return Relude_Option.foldLazy((function (param) {
                                  return Curry._1(T.valErr, "ExpectedValidOption");
                                }), pure, param);
                  }), param);
    };
  };
  var variantFromString = function (stringToVariant, json) {
    return variantFromJson(string, stringToVariant)(json);
  };
  var variantFromInt = function (intToVariant, json) {
    return variantFromJson(intFromNumber, intToVariant)(json);
  };
  var optional = function (decode, json) {
    var match = Js_json.decodeNull(json);
    if (match !== undefined) {
      return Curry._1(M.pure, undefined);
    } else {
      return map((function (v) {
                      return Caml_option.some(v);
                    }), decode)(json);
    }
  };
  var array = function (decode) {
    var map2 = function (f, a, b) {
      var __x = Curry._2(M.map, f, a);
      return Curry._2(M.apply, __x, b);
    };
    var decodeEach = function (arr, _json) {
      return Curry._3(Relude_Array.foldLeft, (function (param, curr) {
                      var pos = param[0];
                      var decoded = Curry._2(T.arrErr, pos, Curry._1(decode, curr));
                      var result = map2((function (param, param$1) {
                              return Relude_Globals.flip(Relude_Array.append, param, param$1);
                            }), param[1], decoded);
                      return [
                              pos + 1 | 0,
                              result
                            ];
                    }), [
                    0,
                    Curry._1(M.pure, [])
                  ], arr)[1];
    };
    return function (param) {
      return flat_map((function (param) {
                    return value(Js_json.decodeArray, "ExpectedArray", param);
                  }), decodeEach, param);
    };
  };
  var list = function (decode) {
    var decode$1 = array(decode);
    var partial_arg = Curry._1(M.map, Relude_Array.toList);
    return function (param) {
      return Relude_Globals.$great$great(decode$1, partial_arg, param);
    };
  };
  var tupleN = function (size, extract, decode) {
    var partial_arg = Curry._1(T.valErr, {
          NAME: "ExpectedTuple",
          VAL: size
        });
    var partial_arg$1 = function (param) {
      return Relude_Option.fold(partial_arg, decode, param);
    };
    var decode$1 = array(M.pure);
    var partial_arg$2 = Curry._1(M.map, extract);
    var partial_arg$3 = function (param) {
      return Relude_Globals.$great$great(decode$1, partial_arg$2, param);
    };
    return function (param) {
      return flat_map(partial_arg$3, partial_arg$1, param);
    };
  };
  var tuple = function (da, db) {
    return tupleN(2, Relude_Tuple.fromArray, (function (param) {
                  var b = param[1];
                  var a = param[0];
                  return Curry._3(map2, Relude_Tuple.make, (function (param) {
                                return Curry._2(T.arrErr, 0, Curry._1(da, a));
                              }), (function (param) {
                                return Curry._2(T.arrErr, 1, Curry._1(db, b));
                              }));
                }));
  };
  var tuple3 = function (da, db, dc) {
    return tupleN(3, Relude_Tuple.fromArray3, (function (param) {
                  var c = param[2];
                  var b = param[1];
                  var a = param[0];
                  return Curry._4(map3, Relude_Tuple.make3, (function (param) {
                                return Curry._1(da, a);
                              }), (function (param) {
                                return Curry._1(db, b);
                              }), (function (param) {
                                return Curry._1(dc, c);
                              }));
                }));
  };
  var tuple4 = function (da, db, dc, dd) {
    return tupleN(4, Relude_Tuple.fromArray4, (function (param) {
                  var d = param[3];
                  var c = param[2];
                  var b = param[1];
                  var a = param[0];
                  return Curry._5(map4, Relude_Tuple.make4, (function (param) {
                                return Curry._1(da, a);
                              }), (function (param) {
                                return Curry._1(db, b);
                              }), (function (param) {
                                return Curry._1(dc, c);
                              }), (function (param) {
                                return Curry._1(dd, d);
                              }));
                }));
  };
  var tuple5 = function (da, db, dc, dd, de) {
    return tupleN(5, Relude_Tuple.fromArray5, (function (param) {
                  var e = param[4];
                  var d = param[3];
                  var c = param[2];
                  var b = param[1];
                  var a = param[0];
                  return Curry._6(map5, Relude_Tuple.make5, (function (param) {
                                return Curry._1(da, a);
                              }), (function (param) {
                                return Curry._1(db, b);
                              }), (function (param) {
                                return Curry._1(dc, c);
                              }), (function (param) {
                                return Curry._1(dd, d);
                              }), (function (param) {
                                return Curry._1(de, e);
                              }));
                }));
  };
  var tupleAtLeast2 = function (da, db) {
    return tupleN(2, Relude_Tuple.fromArrayAtLeast2, (function (param) {
                  var b = param[1];
                  var a = param[0];
                  return Curry._3(map2, Relude_Tuple.make2, (function (param) {
                                return Curry._1(da, a);
                              }), (function (param) {
                                return Curry._1(db, b);
                              }));
                }));
  };
  var tupleAtLeast3 = function (da, db, dc) {
    return tupleN(3, Relude_Tuple.fromArrayAtLeast3, (function (param) {
                  var c = param[2];
                  var b = param[1];
                  var a = param[0];
                  return Curry._4(map3, Relude_Tuple.make3, (function (param) {
                                return Curry._1(da, a);
                              }), (function (param) {
                                return Curry._1(db, b);
                              }), (function (param) {
                                return Curry._1(dc, c);
                              }));
                }));
  };
  var tupleAtLeast4 = function (da, db, dc, dd) {
    return tupleN(4, Relude_Tuple.fromArrayAtLeast4, (function (param) {
                  var d = param[3];
                  var c = param[2];
                  var b = param[1];
                  var a = param[0];
                  return Curry._5(map4, Relude_Tuple.make4, (function (param) {
                                return Curry._1(da, a);
                              }), (function (param) {
                                return Curry._1(db, b);
                              }), (function (param) {
                                return Curry._1(dc, c);
                              }), (function (param) {
                                return Curry._1(dd, d);
                              }));
                }));
  };
  var tupleAtLeast5 = function (da, db, dc, dd, de) {
    return tupleN(5, Relude_Tuple.fromArrayAtLeast5, (function (param) {
                  var e = param[4];
                  var d = param[3];
                  var c = param[2];
                  var b = param[1];
                  var a = param[0];
                  return Curry._6(map5, Relude_Tuple.make5, (function (param) {
                                return Curry._1(da, a);
                              }), (function (param) {
                                return Curry._1(db, b);
                              }), (function (param) {
                                return Curry._1(dc, c);
                              }), (function (param) {
                                return Curry._1(dd, d);
                              }), (function (param) {
                                return Curry._1(de, e);
                              }));
                }));
  };
  var dict = function (decode) {
    var decodeEntries = function (param) {
      if (!param) {
        return function (param) {
          return Curry._1(M.pure, /* [] */0);
        };
      }
      var match = param.hd;
      var value = match[1];
      var key = match[0];
      return Curry._3(map2, (function (decodedValue, rest) {
                    return {
                            hd: [
                              key,
                              decodedValue
                            ],
                            tl: rest
                          };
                  }), (function (param) {
                    return Curry._2(T.objErr, key, Curry._1(decode, value));
                  }), decodeEntries(param.tl));
    };
    var decode$1 = function (param) {
      return value(Js_json.decodeObject, "ExpectedObject", param);
    };
    var f = function (param) {
      return Relude_Globals.$great$great(Js_dict.entries, Relude_Array.toList, param);
    };
    var partial_arg = Curry._1(M.map, f);
    var partial_arg$1 = function (param) {
      return Relude_Globals.$great$great(decode$1, partial_arg, param);
    };
    var decode$2 = function (param) {
      return flat_map(partial_arg$1, decodeEntries, param);
    };
    var partial_arg$2 = Curry._1(M.map, Js_dict.fromList);
    return function (param) {
      return Relude_Globals.$great$great(decode$2, partial_arg$2, param);
    };
  };
  var stringMap = function (decode) {
    var decode$1 = dict(decode);
    var partial_arg = Curry._1(M.map, Js_dict.entries);
    var decode$2 = function (param) {
      return Relude_Globals.$great$great(decode$1, partial_arg, param);
    };
    var f = Curry._2(Relude_Array.foldLeft, (function (acc, param) {
            return Belt_MapString.set(acc, param[0], param[1]);
          }), undefined);
    var partial_arg$1 = Curry._1(M.map, f);
    return function (param) {
      return Relude_Globals.$great$great(decode$2, partial_arg$1, param);
    };
  };
  var at = function (fields, decode) {
    if (!fields) {
      return decode;
    }
    var x = fields.hd;
    var partial_arg = Curry._1(T.objErr, x);
    var partial_arg$1 = at(fields.tl, decode);
    var partial_arg$2 = function (param) {
      return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
    };
    var partial_arg$3 = function (param) {
      return Relude_Globals.$great$great(partial_arg$2, Relude_Globals.$$const, param);
    };
    var decode$1 = function (param) {
      return value(Js_json.decodeObject, "ExpectedObject", param);
    };
    var partial_arg$4 = Curry._1(M.map, (function (__x) {
            return Js_dict.get(__x, x);
          }));
    var partial_arg$5 = function (param) {
      return Relude_Globals.$great$great(decode$1, partial_arg$4, param);
    };
    var partial_arg$6 = function (param) {
      return flat_map(partial_arg$5, (function (param) {
                    return Relude_Option.fold((function (param) {
                                  return Curry._1(T.missingFieldErr, x);
                                }), pure, param);
                  }), param);
    };
    return function (param) {
      return flat_map(partial_arg$6, partial_arg$3, param);
    };
  };
  var field = function (name, decode) {
    return at({
                hd: name,
                tl: /* [] */0
              }, decode);
  };
  var optionalField = function (name, decode) {
    var partial_arg = Curry._1(T.objErr, name);
    var decode$1 = function (param) {
      return value(Js_json.decodeObject, "ExpectedObject", param);
    };
    var partial_arg$1 = Curry._1(M.map, (function (__x) {
            return Js_dict.get(__x, name);
          }));
    var partial_arg$2 = function (param) {
      return Relude_Globals.$great$great(decode$1, partial_arg$1, param);
    };
    var partial_arg$3 = function (param) {
      return flat_map(partial_arg$2, (function (v) {
                    if (v === undefined) {
                      return function (param) {
                        return Curry._1(M.pure, undefined);
                      };
                    }
                    var v$1 = Caml_option.valFromOption(v);
                    return function (param) {
                      return optional(decode, v$1);
                    };
                  }), param);
    };
    return function (param) {
      return Relude_Globals.$great$great(partial_arg$3, partial_arg, param);
    };
  };
  var fallback = function (decode, recovery) {
    return function (param) {
      return alt(decode, (function (param) {
                    return Curry._1(M.pure, recovery);
                  }), param);
    };
  };
  var tupleFromFields = function (param, param$1) {
    return Curry._3(map2, Relude_Tuple.make, field(param[0], param[1]), field(param$1[0], param$1[1]));
  };
  var oneOf = function (decode, rest) {
    return Relude_List.foldLeft(alt, decode)(rest);
  };
  var pipe = function (a, b) {
    return function (param) {
      return apply(b, a, param);
    };
  };
  var optionalField$1 = function (name, decode) {
    var partial_arg = optionalField(name, decode);
    return function (param) {
      return function (param$1) {
        return apply(param, partial_arg, param$1);
      };
    };
  };
  var fallbackField = function (name, decode, recovery) {
    var decode$1 = field(name, decode);
    var partial_arg = function (param) {
      return alt(decode$1, (function (param) {
                    return Curry._1(M.pure, recovery);
                  }), param);
    };
    return function (param) {
      return function (param$1) {
        return apply(param, partial_arg, param$1);
      };
    };
  };
  var field$1 = function (name, decode) {
    var partial_arg = field(name, decode);
    return function (param) {
      return function (param$1) {
        return apply(param, partial_arg, param$1);
      };
    };
  };
  var at$1 = function (fields, decode) {
    var partial_arg = at(fields, decode);
    return function (param) {
      return function (param$1) {
        return apply(param, partial_arg, param$1);
      };
    };
  };
  var hardcoded = function (v) {
    return function (param) {
      var a = function (param) {
        return Curry._1(M.pure, v);
      };
      return function (param$1) {
        return apply(param, a, param$1);
      };
    };
  };
  var run = function (prim, prim$1) {
    return Curry._1(prim$1, prim);
  };
  var Pipeline = {
    succeed: pure,
    pipe: pipe,
    optionalField: optionalField$1,
    fallbackField: fallbackField,
    field: field$1,
    at: at$1,
    hardcoded: hardcoded,
    run: run,
    map: map,
    apply: apply,
    map2: map2,
    map3: map3,
    map4: map4,
    map5: map5,
    pure: pure,
    flatMap: flatMap,
    $$boolean: $$boolean,
    string: string,
    floatFromNumber: floatFromNumber,
    intFromNumber: intFromNumber,
    date: date,
    variantFromJson: variantFromJson,
    variantFromString: variantFromString,
    variantFromInt: variantFromInt,
    optional: optional,
    array: array,
    list: list,
    tuple: tuple,
    tuple2: tuple,
    tuple3: tuple3,
    tuple4: tuple4,
    tuple5: tuple5,
    tupleAtLeast2: tupleAtLeast2,
    tupleAtLeast3: tupleAtLeast3,
    tupleAtLeast4: tupleAtLeast4,
    tupleAtLeast5: tupleAtLeast5,
    tupleFromFields: tupleFromFields,
    dict: dict,
    stringMap: stringMap,
    oneOf: oneOf,
    fallback: fallback
  };
  return {
          map: map,
          apply: apply,
          pure: pure,
          flat_map: flat_map,
          alt: alt,
          BsApplyExtensions: include.BsApplyExtensions,
          applyFirst: include.applyFirst,
          applySecond: include.applySecond,
          map2: map2,
          map3: map3,
          map4: map4,
          map5: map5,
          mapTuple2: include.mapTuple2,
          mapTuple3: include.mapTuple3,
          mapTuple4: include.mapTuple4,
          mapTuple5: include.mapTuple5,
          flatMap: flatMap,
          value: value,
          okJson: M.pure,
          $$boolean: $$boolean,
          string: string,
          floatFromNumber: floatFromNumber,
          intFromNumber: intFromNumber,
          date: date,
          variantFromJson: variantFromJson,
          variantFromString: variantFromString,
          variantFromInt: variantFromInt,
          optional: optional,
          array: array,
          list: list,
          tupleN: tupleN,
          tuple: tuple,
          tuple2: tuple,
          tuple3: tuple3,
          tuple4: tuple4,
          tuple5: tuple5,
          tupleAtLeast2: tupleAtLeast2,
          tupleAtLeast3: tupleAtLeast3,
          tupleAtLeast4: tupleAtLeast4,
          tupleAtLeast5: tupleAtLeast5,
          dict: dict,
          stringMap: stringMap,
          at: at,
          field: field,
          optionalField: optionalField,
          fallback: fallback,
          tupleFromFields: tupleFromFields,
          oneOf: oneOf,
          Pipeline: Pipeline
        };
}

var ParseError;

exports.ParseError = ParseError;
exports.Make = Make;
/* Relude_List Not a pure module */
